import { render, staticRenderFns } from "./UniversalSearch.vue?vue&type=template&id=3112b4cd&scoped=true&"
import script from "./UniversalSearch.vue?vue&type=script&lang=js&"
export * from "./UniversalSearch.vue?vue&type=script&lang=js&"
import style0 from "./UniversalSearch.vue?vue&type=style&index=0&id=3112b4cd&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3112b4cd",
  null
  
)

export default component.exports